<template>
  <v-container fluid class="pa-0">
    <TheTableOfContentItem
      v-for="(section, i) in sections"
      :key="section"
      :section="section"
      :section-number="i"
      :is-current="i === currentSection"
    />

    <template v-if="!filtersShown">
      <AppBorderedSection :sectionNumber="0">
        <div class="text-center">
          <v-btn color="primary" tile block @click="showFilters">{{
            $t(`interface.callToAction`)
          }}</v-btn>
        </div>
      </AppBorderedSection>
    </template>

    <template v-else>
      <AppBorderedSection :sectionNumber="0">
        <div class="title font-weight-bold primary--text">
          {{ $t("content.drawer.intro.title") }}
        </div>
        <TheFilterCount class="pt-2" />
        <div class="text-center">
          <v-btn
            color="primary"
            tile
            block
            :disabled="!filtersApplied"
            @click="resetFilters"
            >{{ $t(`interface.resetFilters`) }}</v-btn
          >
        </div>
      </AppBorderedSection>

      <v-expansion-panels v-model="isOpen" multiple accordion>
        <ExpandableItem :sectionNumber="0">
          <template v-slot:title>
            {{ $t("content.drawer.who.title") }}</template
          >

          <template v-slot:filters>
            <FilterSelect
              v-for="filter in demographicsFilters"
              :key="filter"
              :filter="filter"
              category="demographics"/></template
        ></ExpandableItem>

        <ExpandableItem :sectionNumber="0">
          <template v-slot:title>
            {{ $t("content.drawer.what.title") }}</template
          >

          <template v-slot:filters>
            <TheFilterLegalProblem
          /></template>
        </ExpandableItem>

        <ExpandableItem :sectionNumber="0">
          <template v-slot:title>
            {{ $t("content.drawer.how.title") }}</template
          >

          <template v-slot:filters>
            <FilterSelect
              v-for="filter in resolutionsFilters"
              :key="filter"
              :filter="filter"
              category="resolutions"
            />
          </template>
        </ExpandableItem>
      </v-expansion-panels>

      <AppBorderedSection :sectionNumber="0" class="pb-11">
      </AppBorderedSection>
    </template>
  </v-container>
</template>

<script>
import AppBorderedSection from "@/components/AppBorderedSection.vue";
import TheTableOfContentItem from "@/components/TheTableOfContentItem.vue";
import TheFilterCount from "@/components/TheFilterCount";
import TheFilterLegalProblem from "@/components/TheFilterLegalProblem";
import FilterSelect from "@/components/FilterSelect";
import ExpandableItem from "@/components/ExpandableItem";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  components: {
    AppBorderedSection,
    TheTableOfContentItem,
    TheFilterCount,
    TheFilterLegalProblem,
    FilterSelect,
    ExpandableItem
  },
  data() {
    return {
      isOpen: [],
      sections: ["intro", "who", "what", "how"]
    };
  },
  computed: {
    ...mapState(["currentSection", "filtersShown"]),
    ...mapGetters([
      "demographicsFilters",
      "resolutionsFilters",
      "filtersApplied"
    ])
  },
  methods: {
    ...mapActions(["resetFilters", "showFilters"])
  }
};
</script>

